export async function copyText(value) {
  if (typeof value !== 'string' || !value) return false;
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    // Support browsers where the Clipboard API is unavailable or denied.
    const field = document.createElement('textarea');
    field.value = value;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    const focused = document.activeElement;
    document.body.appendChild(field);
    try {
      field.select();
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      field.remove();
      focused?.focus({ preventScroll: true });
    }
  }
}
